<div class="sdw-assignedto-wrapper">
  @if (
    params.data.assignedToType === 'agent' &&
    params.data.agentCategory !== 'Tool'
  ) {
    <div class="sdw-assignedto">
      <img
        class="bot-img assignedto-icon"
        src="../../../../assets/images/bot-blue.svg"
        height="16"
        width="16"
        alt="Agent" />
      <span class="motif-caption-default-light">
        {{ params.value }}
      </span>
      @if (params.data.hasCanonicalJson && params.data.ruleSubjects?.length) {
        <span
          class="rule-subjects-icon"
          [motif-tooltip]="getRuleSubjectsTooltip(params.data.ruleSubjects)"
          placement="top">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="6.5" stroke="#4EBEEB" />
            <path
              d="M7 6V10"
              stroke="#4EBEEB"
              stroke-width="1.2"
              stroke-linecap="round" />
            <circle cx="7" cy="4" r="0.7" fill="#4EBEEB" />
          </svg>
        </span>
      }

      @if (
        params.data.hasCanonicalJson &&
        params.data.ruleSubjects !== undefined &&
        params.data.ruleSubjects !== null &&
        params.data.ruleSubjects.length === 0 &&
        params.value !== 'Review Agent'
      ) {
        <span
          class="rule-subjects-icon rule-subjects-error-icon"
          [motif-tooltip]="AssignedToConstants.NoCanonicalJsonPresent"
          placement="top">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="6.5" stroke="#FF4444" />
            <path
              d="M7 4V8"
              stroke="#FF4444"
              stroke-width="1.2"
              stroke-linecap="round" />
            <circle cx="7" cy="10" r="0.7" fill="#FF4444" />
          </svg>
        </span>
      }

      @if (params.data.gtPwTaskName) {
        <span
          class="gtpw-icon-wrapper"
          (mouseenter)="onGtPwMouseEnter($event)"
          (mouseleave)="onGtPwMouseLeave()">
          <svg
            class="gtpw-icon"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect
              x="1"
              y="1"
              width="16"
              height="16"
              rx="3"
              stroke="currentColor"
              stroke-width="1.5" />
            <path
              d="M5 9L7.5 11.5L13 6"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      }
    </div>
  }

  @if (
    params.data.assignedToType === 'agent' &&
    params.data.agentCategory === 'Tool'
  ) {
    <div class="sdw-assignedto">
      <img
        class="assignedto-icon"
        src="../../../../assets/images/gear.svg"
        height="16"
        width="16"
        alt="Tool" />
      <span class="motif-caption-default-light">
        {{ params.value }}
      </span>

      @if (params.data.hasCanonicalJson && params.data.ruleSubjects?.length) {
        <span
          class="rule-subjects-icon"
          [motif-tooltip]="getRuleSubjectsTooltip(params.data.ruleSubjects)"
          placement="top">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="6.5" stroke="#4EBEEB" />
            <path
              d="M7 6V10"
              stroke="#4EBEEB"
              stroke-width="1.2"
              stroke-linecap="round" />
            <circle cx="7" cy="4" r="0.7" fill="#4EBEEB" />
          </svg>
        </span>
      }

      @if (
        params.data.hasCanonicalJson &&
        params.data.ruleSubjects !== undefined &&
        params.data.ruleSubjects !== null &&
        params.data.ruleSubjects.length === 0
      ) {
        <span
          class="rule-subjects-icon rule-subjects-error-icon"
          [motif-tooltip]="AssignedToConstants.NoSourceDataConfigured"
          placement="top">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="6.5" stroke="#FF4444" />
            <path
              d="M7 4V8"
              stroke="#FF4444"
              stroke-width="1.2"
              stroke-linecap="round" />
            <circle cx="7" cy="10" r="0.7" fill="#FF4444" />
          </svg>
        </span>
      }

      @if (params.data.gtPwTaskName) {
        <span
          class="gtpw-icon-wrapper"
          (mouseenter)="onGtPwMouseEnter($event)"
          (mouseleave)="onGtPwMouseLeave()">
          <svg
            class="gtpw-icon"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect
              x="1"
              y="1"
              width="16"
              height="16"
              rx="3"
              stroke="currentColor"
              stroke-width="1.5" />
            <path
              d="M5 9L7.5 11.5L13 6"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      }
    </div>
  }

  @if (params.data.assignedToType === 'user') {
    <div class="sdw-assignedto">
      <i class="pi pi-user assignedto-icon"></i>
      <span class="motif-caption-default-light">
        {{ params.value }}
      </span>

      @if (params.data.gtPwTaskName) {
        <span
          class="gtpw-icon-wrapper"
          (mouseenter)="onGtPwMouseEnter($event)"
          (mouseleave)="onGtPwMouseLeave()">
          <svg
            class="gtpw-icon"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect
              x="1"
              y="1"
              width="16"
              height="16"
              rx="3"
              stroke="currentColor"
              stroke-width="1.5" />
            <path
              d="M5 9L7.5 11.5L13 6"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      }
    </div>
  }
</div>
